import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPassowrdTermsFail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.96783 7.38195C6.35836 7.77247 6.99152 7.77247 7.38204 7.38194C7.77257 6.99141 7.77256 6.35825 7.38203 5.96773L5.33915 3.92487L7.55688 1.7071C7.94741 1.31657 7.9474 0.683409 7.55687 0.292888C7.16635 -0.0976333 6.53318 -0.0976282 6.14266 0.292899L3.92492 2.51067L1.7071 0.292888C1.31657 -0.0976336 0.683409 -0.0976285 0.292888 0.292899C-0.0976338 0.683426 -0.0976285 1.31659 0.292899 1.70711L2.51072 3.9249L0.46782 5.96783C0.0772986 6.35836 0.0773037 6.99152 0.467831 7.38204C0.858359 7.77257 1.49152 7.77256 1.88204 7.38203L3.92494 5.3391L5.96783 7.38195Z",
		fill: "#EE2B2B"
	})
});
export default SvgPassowrdTermsFail;
